import React from 'react'

const Submit = ({ label }) => {
  return (
    <button type='submit' className='btn'>{label}</button>
  )
}

export default Submit
